"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelayCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Floating point value in seconds that offsets the position of the following
 * song notation. If value is negative, following song notation will overlap
 * with the previous. All notes should be placed in such way that notes after
 * #DELAY do not appear earlier or at the same time as the notes before. Can be
 * placed in the middle of a measure.
 *
 * **Example:**
 *
 * ```
 * #DELAY 0.02
 * ```
 */
class DelayCommand extends Command_1.Command {
    constructor(value) {
        super(CommandType_1.CommandType.Delay);
        this.value = value;
    }
    static parse(args) {
        if (args.length === 0) {
            return undefined;
        }
        const value = parseFloat(args[0]);
        if (isNaN(value)) {
            return undefined;
        }
        return new DelayCommand(value);
    }
    toString() {
        return `${super.toString()} ${this.value}`;
    }
}
exports.DelayCommand = DelayCommand;
